import React from 'react';
import {
  ContainerLoadInit,
  ContainerFooter,
  TextLI,
  TitleFooter
} from '../style';
import DateHelpers from '@/core/helpers/DateHelper';
import Spinner from '@/presentation/components/Spinner';
import ErrorMessage from '@/presentation/components/Error';
import ReusableButton from '@/presentation/reusables/Button';
import {
  PaymentDetail,
  PaymentDetails,
  PaymentTotal
} from '@/presentation/modules/payments/components/PaymentDetails/styled';
import {
  TornEdgeBottom,
  TornEdgeTop
} from '@/presentation/modules/payments/modules/PaymentDetails/PaymentDetails.styled';

interface RenderInfoProps {
  isLoadingDataDiscount: boolean;
  dataDiscount: any;
  isDisabled: boolean;
  handlerActivateDiscount: () => void;
}

const RenderInfo = ({
  isLoadingDataDiscount,
  dataDiscount,
  isDisabled,
  handlerActivateDiscount
}: RenderInfoProps) => {
  if (isLoadingDataDiscount) {
    return (
      <ContainerLoadInit>
        <Spinner height={80} colorText="#5B36F2" />
      </ContainerLoadInit>
    );
  }
  if (!dataDiscount) {
    return <ErrorMessage />;
  }
  return (
    <>
      <PaymentDetails
        data-testid="discount-full-cycle"
        style={{ borderRadius: 0 }}
      >
        <TornEdgeTop />
        <PaymentDetail>
          <div className="item">
            <span className="subtotal-title">
              Pago regular por {dataDiscount?.totalInstallments} cuotas
            </span>
            <span>S/ {dataDiscount?.totalAmount}</span>
          </div>
          <div className="discount-subtitle">
            Incluye los beneficios que correspondan en tu cuota regular.
          </div>
          {dataDiscount?.totalDiscount && (
            <div className="discount-item">
              <span>
                <div className="discount-title">Descuento ciclo completo</div>
              </span>
              <span className="discount-percentage">
                -S/ {dataDiscount?.totalDiscount}
              </span>
            </div>
          )}
        </PaymentDetail>
        <hr className="divider-primary" />
        <PaymentTotal>
          <span>Total a pagar</span>
          <span>S/ {dataDiscount?.amountWithBenefit}</span>
        </PaymentTotal>
        <TornEdgeBottom />
      </PaymentDetails>
      <ContainerFooter>
        <TitleFooter>Cuando actives el descuento:</TitleFooter>
        <TextLI>
          Las {dataDiscount?.totalInstallments} cuotas aparecerán como un solo
          pago en todas las opciones de pago.
        </TextLI>
        <TextLI>
          Podrás desactivar el descuento y ver tus cuotas separadas nuevamente.
        </TextLI>
        <TextLI>
          Si no pagas antes del{' '}
          {DateHelpers.formatDateWhitFullMonth(Number(dataDiscount?.endDate))}{' '}
          se desactivará automáticamente.
        </TextLI>
        <TextLI>
          Luego de activar el descuento, podrás visualizarlo en la sección
          Pagos.
        </TextLI>
      </ContainerFooter>
      <ReusableButton
        disabled={isDisabled}
        onClick={() => (isDisabled ? undefined : handlerActivateDiscount())}
        style={{ marginTop: '24px' }}
        data-testid="button-activate-discount"
      >
        Activar descuento
      </ReusableButton>
    </>
  );
};

export default RenderInfo;
